/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewPositionDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewPositionDto } from '../api-models';
// @ts-ignore
import { UpdatePositionDto } from '../api-models';
/**
 * PositionApi - axios parameter creator
 * @export
 */
export const PositionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionCoveringPositionsGet: async (positionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Position/covering-positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {boolean} [filteredByOpeningTemplates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionGet: async (filteredByOpeningTemplates?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filteredByOpeningTemplates !== undefined) {
                localVarQueryParameter['filteredByOpeningTemplates'] = filteredByOpeningTemplates;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('positionIdGet', 'id', id)
            const localVarPath = `/Position/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {number} id 
         * @param {UpdatePositionDto} [updatePositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionIdPut: async (id: number, updatePositionDto?: UpdatePositionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('positionIdPut', 'id', id)
            const localVarPath = `/Position/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePositionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Convert legacy Allowable Budget Group Scheduling Labor Levels  to Pro Position Coverage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionSyncAllowableBudgetGroupsPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Position/sync-allowable-budget-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PositionApi - functional programming interface
 * @export
 */
export const PositionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PositionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionCoveringPositionsGet(positionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionCoveringPositionsGet(positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {boolean} [filteredByOpeningTemplates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionGet(filteredByOpeningTemplates?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionGet(filteredByOpeningTemplates, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {number} id 
         * @param {UpdatePositionDto} [updatePositionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionIdPut(id: number, updatePositionDto?: UpdatePositionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewPositionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionIdPut(id, updatePositionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Convert legacy Allowable Budget Group Scheduling Labor Levels  to Pro Position Coverage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async positionSyncAllowableBudgetGroupsPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.positionSyncAllowableBudgetGroupsPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PositionApi - factory interface
 * @export
 */
export const PositionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PositionApiFp(configuration)
    return {
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {PositionApiPositionCoveringPositionsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionCoveringPositionsGet(requestParameters: PositionApiPositionCoveringPositionsGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto> {
            return localVarFp.positionCoveringPositionsGet(requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {PositionApiPositionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionGet(requestParameters: PositionApiPositionGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewPositionDto> {
            return localVarFp.positionGet(requestParameters.filteredByOpeningTemplates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {PositionApiPositionIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionIdGet(requestParameters: PositionApiPositionIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewPositionDto> {
            return localVarFp.positionIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Use Budget Group APIs from LaborLevelController instead
         * @param {PositionApiPositionIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionIdPut(requestParameters: PositionApiPositionIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewPositionDto> {
            return localVarFp.positionIdPut(requestParameters.id, requestParameters.updatePositionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Convert legacy Allowable Budget Group Scheduling Labor Levels  to Pro Position Coverage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionSyncAllowableBudgetGroupsPost(options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.positionSyncAllowableBudgetGroupsPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for positionCoveringPositionsGet operation in PositionApi.
 * @export
 * @interface PositionApiPositionCoveringPositionsGetRequest
 */
export interface PositionApiPositionCoveringPositionsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PositionApiPositionCoveringPositionsGet
     */
    readonly positionId?: number
}

/**
 * Request parameters for positionGet operation in PositionApi.
 * @export
 * @interface PositionApiPositionGetRequest
 */
export interface PositionApiPositionGetRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PositionApiPositionGet
     */
    readonly filteredByOpeningTemplates?: boolean
}

/**
 * Request parameters for positionIdGet operation in PositionApi.
 * @export
 * @interface PositionApiPositionIdGetRequest
 */
export interface PositionApiPositionIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PositionApiPositionIdGet
     */
    readonly id: number
}

/**
 * Request parameters for positionIdPut operation in PositionApi.
 * @export
 * @interface PositionApiPositionIdPutRequest
 */
export interface PositionApiPositionIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof PositionApiPositionIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdatePositionDto}
     * @memberof PositionApiPositionIdPut
     */
    readonly updatePositionDto?: UpdatePositionDto
}

/**
 * PositionApi - object-oriented interface
 * @export
 * @class PositionApi
 * @extends {BaseAPI}
 */
export class PositionApi extends BaseAPI {
    /**
     * 
     * @summary Use Budget Group APIs from LaborLevelController instead
     * @param {PositionApiPositionCoveringPositionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionCoveringPositionsGet(requestParameters: PositionApiPositionCoveringPositionsGetRequest = {}, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionCoveringPositionsGet(requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Use Budget Group APIs from LaborLevelController instead
     * @param {PositionApiPositionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionGet(requestParameters: PositionApiPositionGetRequest = {}, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionGet(requestParameters.filteredByOpeningTemplates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Use Budget Group APIs from LaborLevelController instead
     * @param {PositionApiPositionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionIdGet(requestParameters: PositionApiPositionIdGetRequest, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Use Budget Group APIs from LaborLevelController instead
     * @param {PositionApiPositionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionIdPut(requestParameters: PositionApiPositionIdPutRequest, options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionIdPut(requestParameters.id, requestParameters.updatePositionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Convert legacy Allowable Budget Group Scheduling Labor Levels  to Pro Position Coverage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PositionApi
     */
    public positionSyncAllowableBudgetGroupsPost(options?: AxiosRequestConfig) {
        return PositionApiFp(this.configuration).positionSyncAllowableBudgetGroupsPost(options).then((request) => request(this.axios, this.basePath));
    }
}
